import React from 'react';
function Search() {
  return (
    <div>
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6256_48698)">
          <path
            d="M6.99668 13.9978C10.8613 13.9978 13.9941 10.865 13.9941 7.00036C13.9941 3.13575 10.8613 0.00292969 6.99668 0.00292969C3.13207 0.00292969 -0.000785828 3.13578 -0.000785828 7.00039C-0.000785828 10.865 3.1321 13.9978 6.99668 13.9978ZM6.99668 2.00221C9.75711 2.00221 11.9949 4.23996 11.9949 7.00039C11.9949 9.76082 9.75711 11.9986 6.99668 11.9986C4.23625 11.9986 1.9985 9.76082 1.9985 7.00039C1.9985 4.23996 4.23628 2.00221 6.99668 2.00221Z"
            fill="black"
          />
          <path
            d="M14.9946 15.997C15.2603 15.9986 15.5157 15.8943 15.7043 15.7071C16.0963 15.3183 16.0989 14.6854 15.7101 14.2934C15.7082 14.2915 15.7062 14.2896 15.7043 14.2876L11.9457 10.529C11.5399 10.137 10.8932 10.1482 10.5012 10.554C10.1092 10.9598 10.1204 11.6065 10.5262 11.9985L14.2848 15.7071C14.4735 15.8943 14.7288 15.9986 14.9946 15.997Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_6256_48698">
            <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 1 16 0)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default Search;
